import { formatPersonName } from './formatPersonName';

/** Unique quote number: OFF-YYYYMMDD-##### (5-digit suffix). */
export function generateQuoteNumber(prefix = 'OFF') {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const suffix = String(Math.floor(Math.random() * 100000)).padStart(5, '0');
  return `${prefix}-${year}${month}${day}-${suffix}`;
}

/** Issue date encoded in OFF-YYYYMMDD-#####, or null if the number has no date. */
export function parseQuoteNumberDate(quoteNumber) {
  const match = String(quoteNumber || '').match(/(?:OFF-)?(\d{4})(\d{2})(\d{2})(?:-|$)/i);
  if (!match) return null;
  const parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Display label for Offerte / Referentie fields (optionally includes client name). */
export function formatQuoteDisplayReference(quoteNumber, clientName) {
  const number = (quoteNumber || '').trim();
  const name = formatPersonName(clientName);
  if (number && name) return `${number} – ${name}`;
  return number || name || 'CONFI-GO';
}
